declare global {
  interface Window {
    _env: any;
  }
}

export default {
  env: window._env?.REACT_APP_ENVIRONMENT,
  authApiBaseUrl: window._env?.REACT_APP_AUTH_API_BASE_URL,
  externalDeveloperPortalServiceBaseUrl:
    window._env?.REACT_APP_EXTERNAL_DEVELOPER_PORTAL_SERVICE_BASE_URL,
  forgotPassword: window._env?.REACT_APP_FORGOT_PASSWORD_URL,
  datadogApplicationId: '58fb8c8f-7328-4bd5-9a82-3fb2c6d9a952',
  datadogClientToken: 'pub6ca07865f1f59ae900fe8165a11f980f',
  datadogService: 'identity-provider',
};
